export const stringLength = {
  TITLE: 90
}

export const fleetsTab = {
  FLEETS_DATA: 1,
  FLEETS_DOSSIERS: 2,
  FLEETS_RELATED_DOSSIERS: 3,
  FLEETS_HISTORICALS: 4,
  FLEETS_ECONOMIC: 5,
  FLEETS_DOCUMENTS: 6,
  FLEETS_CONDITIONS: 7,
  FLEETS_AUDITS: 8
}
